<script lang="ts">
  export let svgStyles: string = ''
</script>

<svg class={svgStyles} width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M1.908 0.5H8.5V7.092H7.51119V2.2259L1.23709 8.5L0.5 7.76291L6.7741 1.4888H1.908V0.5Z" fill="white" />
</svg>
